@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.searchButtonWrapper {
  display: flex;
  align-items: center;
}

.districtInfo {
  margin: 0 variables.$std-margin-md;
}
